import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propStr, propFunc, propShape, propOneOf, } from '../../../../helpers/custom-prop-types';
import SlideSearchRegistrationFormInner from './SlideSearchRegistrationFormInner';
/**
 * 氏名の更新を行うためのフォーム
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchUpdateNameAndPositionForm = (props) => {
    const { error, form, handleSubmit, kanaRef, submitting, userMode } = props;
    return (_jsx(SlideSearchRegistrationFormInner, { error: error, form: form, handleSubmit: handleSubmit, headerDescriptionText: 'この度は、ご登録いただきありがとうございます\nまずは、下記を入力・確認の上、ご利用を開始ください', headerText: '保有スライドをフル活用する\n新しい資料作成の体験へ、ようこそ！', kanaRef: kanaRef, submitText: '利用を開始する', submitting: submitting, userMode: userMode }));
};
SlideSearchUpdateNameAndPositionForm.propTypes = {
    error: propStr(),
    form: propStr(),
    handleSubmit: propFunc(),
    kanaRef: propShape().isRequired,
    submitting: propBool(),
    userMode: propOneOf(['guest', 'client', 'free_professional', 'professional'])
        .isRequired,
};
SlideSearchUpdateNameAndPositionForm.defaultProps = {
    error: undefined,
    form: '',
    handleSubmit: null,
    submitting: false,
};
export default SlideSearchUpdateNameAndPositionForm;
